import React from 'react';
import styles from './NutritionalValue.module.css';

export default function NutritionalValue({ activeIngredient }) {
  // console.log('activeIngredient === ', activeIngredient);

  const getVlue = (value) => {
    if (value) {
      Number(value);
      return Number(value.toFixed(1));
    }
    return '-';
  };
  return (
    <div className={styles.table_wrapper}>
      <div className={styles.table_item}>Ккал</div>
      <div className={styles.table_item}>Білки</div>
      <div className={styles.table_item}>Жири</div>
      <div className={styles.table_item}>Вугл</div>
      <div className={styles.table_item}>{getVlue(activeIngredient.сaloriesIngredient)}</div>
      <div className={styles.table_item}>{getVlue(activeIngredient.proteinIngredient)}</div>
      <div className={styles.table_item}>{getVlue(activeIngredient.fatsIngredient)}</div>
      <div className={styles.table_item}>{getVlue(activeIngredient.carbohydratesIngredient)}</div>
    </div>
  );
}
